<template>
  <div id="questionView">
    <h2 class="bo">欢迎来到MYOJ！</h2>
    <!--    <a-card>-->
    <div class="card">
      <a-form :model="form" layout="inline" class="bo">
        <a-form-item label="题目名称">
          <a-input
            v-model="form.title"
            placeholder="请输入题目名称"
            style="min-width: 240px"
          />
        </a-form-item>
        <a-form-item label="标签">
          <a-input-tag
            v-model="form.tags"
            placeholder="请输入标签(回车确认)"
            style="min-width: 240px"
          />
        </a-form-item>
        <a-form-item label="题号">
          <a-input
            v-model="form.id"
            placeholder="请输入题号"
            style="min-width: 240px"
          />
        </a-form-item>
        <a-form-item>
          <a-button @click="doSearch" type="primary">搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table
        :columns="columns"
        :data="dataList"
        :pagination="{
          showTotal: true,
          pageSize: searchParams.pageSize,
          current: searchParams.current,
          total: total,
          showPageSize: true,
          showJumper: true,
        }"
        @page-change="changePageNum"
        @page-size-change="changePageSize"
      >
        <template #tags="{ record }">
          <a-space>
            <a-tag
              color="#7bc616"
              v-for="(tag, index) in record.tags"
              :key="index"
              >{{ tag }}
            </a-tag>
          </a-space>
        </template>
        <template #acRate="{ record }">
          <a-space>
            <a-tag color="#0fc6c2">
              {{ calculateAcRate(record) }}
            </a-tag>
          </a-space>
        </template>
        <template #createTime="{ record }">
          <a-space>
            {{ timeFormat(record.createTime) }}
          </a-space>
        </template>
        <template #detail="{ record }">
          <a-space>
            <a-button type="primary" @click="toDetailPage(record)"
              >详情
            </a-button>
          </a-space>
        </template>
      </a-table>
    </div>
    <!--    </a-card>-->
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { MyAxios } from "@/plugins/axios";
import { useRouter } from "vue-router";
import moment from "moment-timezone/moment-timezone-utils";

const router = useRouter();
const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  current: 1,
  pageSize: 10,
  title: "",
  tags: [],
  id: "",
});
const form = ref({
  ...searchParams.value,
});

/**
 * 加载数据
 */
const loadData = async () => {
  await MyAxios.post("/question/list/page/vo", searchParams.value).then(
    (res) => {
      if (res.data.code === 0) {
        dataList.value = res.data.data.records;
        total.value = res.data.data.total;
        // console.log(res.data.data);
      } else {
        message.error("加载失败：" + res.data.message);
      }
    }
  );
};
const calculateAcRate = (record: any) => {
  let rate = !record.submitNum ? "0" : record.acceptNum / record.submitNum;
  rate = Number(rate) * 100;
  return (
    rate.toFixed(2) + "% (" + record.acceptNum + "/" + record.submitNum + ")"
  );
};
const timeFormat = (time: any) => {
  return moment(time).tz("Asia/Shanghai").format("YYYY-MM-DD");
};
onMounted(() => {
  loadData();
});
watchEffect(() => {
  loadData();
});

const changePageNum = (current: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: current,
  };
};
const changePageSize = (pageSize: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: pageSize,
  };
};
const doSearch = () => {
  searchParams.value = {
    ...searchParams.value,
    id: form.value.id,
    title: form.value.title,
    tags: form.value.tags,
    current: 1,
  };
};
const toDetailPage = (record: any) => {
  router.push({
    path: "./detail/question",
    query: {
      id: record.id,
    },
  });
};

const columns = [
  {
    title: "题号",
    dataIndex: "id",
  },
  {
    title: "题目名称",
    dataIndex: "title",
  },
  {
    title: "标签",
    slotName: "tags",
  },
  // {
  //   title: "通过率",
  //   slotName: "acRate",
  // },
  {
    title: "创建时间",
    slotName: "createTime",
  },
  {
    slotName: "detail",
  },
];
</script>

<style scoped>
#questionView {
  max-width: 1280px;
  margin: 0 auto;
}

.card {
  margin: 40px;
  margin-top: 10px;
}

.bo {
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>
